/** 只转换用户展示文案，诊断上报和 Agent 原始错误仍保留。 */
export function getChatErrorDisplayMessage(message: unknown, code?: unknown): string {
  let raw = typeof message === "string" ? message.trim() : "";
  // 兼容聊天状态层保存的红字容器；仅接受这个固定容器，不渲染上游 HTML。
  const wrapped = raw.match(/^<font color=['"]red['"]>([^<>]*)<\/font>$/);
  if (wrapped) {
    raw = wrapped[1].replace(/&lt;/g, "<").replace(/&gt;/g, ">")
      .replace(/&amp;/g, "&").trim();
  }
  const errorCode = String(code || "");
  if (errorCode === "MODEL_EMPTY_RESPONSE") return "模型未返回有效内容，请重试。";
  if (["503", "502", "CLIPROXY_UPSTREAM_UNAVAILABLE"].includes(errorCode)
      || /\b50[23]\s+(?:Service|Bad Gateway)/i.test(raw)) {
    return "模型服务暂时不可用，请稍后重试。";
  }
  if (["504", "CLIENT_TIMEOUT"].includes(errorCode)) return "模型响应超时，请稍后重试。";
  if (!raw || /<\/?[a-z!][^>]*>|&lt;\/?[a-z!]/i.test(raw)) {
    return "本次生成未能完成，请稍后重试。";
  }
  return raw.slice(0, 500);
}

export function escapeChatErrorText(message: string): string {
  return message.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
